import React, { Fragment } from "react";
import { Typography, Stack, Box } from "@mui/material";
import { InputField } from "./input";
import { CustomTextArea } from "../../../components/fields/CustomTextArea/CustomTextArea";

export default function SocialReach() {
  const SOCIAL_LINKS = [
    {
      name: "instagram",
      label: "Instagram",
      placeholder: "@handle",
    },
    {
      name: "linkedin",
      label: "LinkedIn",
      placeholder: "https://www.linkedin.com/in/<your name>/",
    },
    {
      name: "twitter",
      label: "X(Twitter)",
      placeholder: "@handle",
    },
  ];
  return (
    <Fragment key="social reach">
      <Typography
        variant="h4"
        sx={{
          color: "var(--Base-1000, #000)",
          fontSize: "24px",
          fontStyle: "normal",
          fontWeight: 900,
          lineHeight: "132%",
        }}
      >
        Social Reach
      </Typography>
      <hr style={{ color: "var(--border)", marginTop: "16px" }} />

      <Stack width={1} spacing={3} mb={3} mt={2}>
        <Box className="flex mb-3 w-full" sx={{ gap: 2 }}>
          {SOCIAL_LINKS.map((link) => (
            <InputField
              key={link.name}
              name={link.name}
              label={`${link.label} Handle`}
              placeholder={link.placeholder}
              required={false}
            />
          ))}
        </Box>
        <CustomTextArea
          name="referringSource"
          label="Where did you find us?"
          placeholder="On social media"
          rows={3}
          required
        />
      </Stack>
    </Fragment>
  );
}
